export const BEM_BLOCK_NAME: string = 'hc_giving_campaign_commitment';
